import { readFileSync } from 'fs';
import { HiGHS as BaseHiGHS } from './solver.js';
export { Model, Var, LinExpr, Constraint, Solution, sum, exprBounds, isIntegral, } from './model/index.js';
/** HiGHS solver with Node.js-specific file reading support. */
export class HiGHS extends BaseHiGHS {
    /** Reads a problem from a file path. The format is inferred from the extension. */
    async readProblem(path) {
        const content = readFileSync(path, 'utf-8');
        const ext = path.split('.').pop() || 'lp';
        await this.parse(content, ext);
    }
    static async create(options) {
        const base = await BaseHiGHS.create(options);
        return Object.setPrototypeOf(base, HiGHS.prototype);
    }
}
//# sourceMappingURL=index.node.js.map